<template>
    <div class="shopInfoMain">
        <div
            style="
                display: flex;
                align-items: center;
            "
        >
            <div style="flex-shrink:0;">店铺名称:&nbsp;&nbsp;</div>
            <div style="white-space:nowrap;overflow:auto;flex-grow:1;">{{ shopName }}</div>
        </div>
        <div
            style="
                display: flex;
                align-items: center;
            "
        >
            <span style="flex-shrink: 0;">商家电话:&nbsp;&nbsp;</span>
            <span style="flex-grow:1;white-space:nowrap;overflow:auto;">{{shopMobile}}</span>
            <a :href="`tel:${shopMobile}`" style="flex-shrink: 0;">
                <button>拨打</button>
            </a>
        </div>
        <div class="horizonGully" />

        <div
            style="
                display: flex;
                align-items: center;
            "
        >
            <div style="white-space:nowrap;overflow:auto;flex-grow:1;">{{ shopAddress }}</div>
            <div class="verticalGully" style="flex-shrink: 0;" />
            <button style="flex-shrink: 0;" @click="
                urlLocate(
                    `https://uri.amap.com/marker?position=${shopPositionLongitude},${shopPositionLatitude}&name=${shopAddress}`
                )
            ">导航</button>
        </div>
        <div class="horizonGully" />

        <div
            id="container"
            style="width: 100%; height: 250px"
        ></div>
        <div class="horizonGully" />

        <div
            style="
                font-weight: 800;
                text-align: center;
            "
        >
            商家从业资质
        </div>
        <div
            style="
                font-weight: 800;
                text-align: center;
            "
        >
            营业执照
        </div>
        <div
            style="
                position: relative;
                width: 100%;
                height: 0;
                padding-top: calc(100% * 910 / 1404);
            "
            v-if="shopCertificateImg && shopCertificateImg.length > 0"
        >
            <BaseImage
                style="
                    width: 100%;
                    height: 100%;
                    top: 0px;
                    left: 0px;
                    position: absolute;
                "
                :url="getImgUrl(shopCertificateImg)"
            />
        </div>
        <div class="horizonGully" />

        <div
            style="
                font-weight: 800;
            "
        >
            食品经营许可证
        </div>
        <div
            style="
                position: relative;
                width: 100%;
                height: 0;
                padding-top: calc(100% * 910 / 1404);
            "
            v-if="shopFoodCertificateImg && shopFoodCertificateImg.length > 0"
        >
            <BaseImage
                style="
                    width: 100%;
                    height: 100%;
                    top: 0px;
                    left: 0px;
                    position: absolute;
                "
                :url="getImgUrl(shopFoodCertificateImg)"
            />
        </div>
        <div v-else style="text-align:center;">无</div>
    </div>
</template>

<script>
export default {
    name: 'ShopInfo',

    props: {
        shopName: {
            type: String,
            required: true,
        },

        shopMobile: {
            type: String,
            required: true,
        },

        shopAddress: {
            type: String,
            required: true,
        },

        shopPositionLongitude: {
            thpe: Number,
            required: true,
        },

        shopPositionLatitude: {
            thpe: Number,
            required: true,
        },

        shopCertificateImg: {
            type: String,
            required: true,
        },
        shopFoodCertificateImg: {
            type: String,
            required: true,
        },
    },

    methods: {
        drawMap() {
            window.map = new AMap.Map('container', {
                zoom: 15, //级别
                center: [this.shopPositionLongitude, this.shopPositionLatitude], //中心点坐标
                viewMode: '3D', //使用3D视图
            })

            // 创建一个 Marker 实例：
            var marker = new AMap.Marker({
                position: new AMap.LngLat(
                    this.shopPositionLongitude,
                    this.shopPositionLatitude
                ), // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
                title: this.shopName,
            })

            // 将创建的点标记添加到已有的地图实例：
            window.map.add(marker)
        },
    },
}
</script>

<style lang="scss" scoped>

.shopInfoMain {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    padding: $padding;
    font-size: $fontSizeContent;
    line-height: 2em;
}

</style>